import React, { useState, useEffect, useRef } from "react";

function DropdownSelect(props: { options: any[]; options2: string[]; def: string; setSelectedOption: any, selectedOption: any, onChange?: any }) {
    const { options, options2, setSelectedOption, def, selectedOption } = props;
    const [isOpen, setIsOpen] = useState(false);
    const [searchString, setSearchString] = useState('');
    const [selected, setSelected] = useState(selectedOption);
    const dropdownRef = useRef<HTMLDivElement>(null);

    const inputRef = useRef<HTMLInputElement | null>(null);

    const handleSelect = (option: any) => {
        setSelected(option);
        setIsOpen(false);
        setSelectedOption(option);
        if (props.onChange) props.onChange(option);
    };

    const filteredOptions = options.filter((option) => {
        const optionName = typeof option === "object" ? option.name : option;
        return optionName.toLowerCase().includes(searchString.toLowerCase());
    });

    useEffect(() => {
        setSelected(selectedOption);
    }, [selectedOption]);

    useEffect(() => {
        const handleClickOutside = (event: MouseEvent) => {
            if (dropdownRef.current && !dropdownRef.current.contains(event.target as Node)) {
                setIsOpen(false);
            }
        };

        // Add event listener to detect clicks outside
        document.addEventListener("mousedown", handleClickOutside);

        // Cleanup the event listener on component unmount
        return () => {
            document.removeEventListener("mousedown", handleClickOutside);
        };
    }, []);

    useEffect(() => {
        if (isOpen && inputRef.current) {
          inputRef?.current?.focus(); // Focus the input when it is rendered
        }
    }, [isOpen]);

    return (
        <div ref={dropdownRef} className="w-full relative inline-block bg-[#FFFFFF] border border-[#E3E3E3] rounded-lg">
            {!isOpen && <button
                id="dropdownInformationButton"
                onClick={() => setIsOpen(!isOpen)}
                className="w-full text-[#000000] font-primary font-medium text-sm rounded-sm px-5 py-2.5 text-center inline-flex justify-between items-center"
                type="button"
            >
                {typeof selected === "object" ? selected?.name ? selected?.name : def: selected ? selected : def }
                <svg
                    className="w-2.5 h-2.5 ms-3"
                    aria-hidden="true"
                    xmlns="http://www.w3.org/2000/svg"
                    fill="none"
                    viewBox="0 0 10 6"
                >
                    <path
                        stroke="currentColor"
                        strokeLinecap="round"
                        strokeLinejoin="round"
                        strokeWidth="2"
                        d="m1 1 4 4 4-4"
                    />
                </svg>
            </button>}

            {/*search input*/}
            {isOpen && <input
                ref={inputRef} 
                type="text"
                placeholder="Search option"
                value={searchString}
                onChange={(e) => setSearchString(e.target.value)}
                className="w-full text-[#000000] font-primary font-medium text-sm rounded-lg px-5 py-2.5 inline-flex justify-between items-center"
            />}
            {/*search input*/}

            {isOpen && (
                <div
                    id="dropdownInformation"
                    className="w-full z-10 absolute left-0 mt-2 bg-white divide-y divide-[#E3E3E3] rounded-lg border border-[#DEE7F4] max-h-48 overflow-y-auto custom-scrollbar"
                >
                    <ul className="py-2 text-[#000000] text-sm" aria-labelledby="dropdownInformationButton">
                        {filteredOptions.map((option, index) => (
                            <li key={`options-${index}`}>
                                <button
                                    onClick={() => handleSelect(option)}
                                    className="block w-full px-4 py-2 text-left font-normal font-primary hover:bg-[#EDF1F9] hover:font-semibold"
                                >
                                    {typeof option === "object"? option.name : option}
                                </button>
                            </li>
                        ))}
                    </ul>

                    {options2.length > 0 && (
                        <>
                            <hr className="border-t" />
                            <ul className="py-2 text-[#000000] text-sm">
                                {options2.map((option, index) => (
                                    <li key={`options2-${index}`}>
                                        <button
                                            onClick={() => handleSelect(option)}
                                            className="block w-full px-4 py-2 text-left font-normal font-primary hover:bg-[#EDF1F9] hover:font-semibold"
                                        >
                                            {option}
                                        </button>
                                    </li>
                                ))}
                            </ul>
                        </>
                    )}
                </div>
            )}
        </div>
    );
}

export default DropdownSelect;
